import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react'
import React, { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import './CloseApplyModal.scss'

const baseClass = 'CloseApplyModal'

interface CloseApplyModalProps {
    isModalOpen: boolean
    setIsModalOpen: (isOpen: boolean) => void
    onCloseApply: () => void
}

const CloseApplyModal: FC<CloseApplyModalProps> = ({ isModalOpen, setIsModalOpen, onCloseApply }) => {
    const { t } = useTranslation()
    return (
        <Modal
            isCentered
            size={'xl'}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            motionPreset="slideInBottom"
        >
            <ModalOverlay className={`${baseClass}__overlay`} />

            <ModalContent className={`${baseClass}__content`}>
                <ModalHeader className={`${baseClass}__header`}>
                    <Text mb={'14px'} fontWeight={600}>
                        Exit application form
                    </Text>
                    <ModalCloseButton
                        className={`${baseClass}__close-button`}
                        // top={{
                        //     base: '14px',
                        //     sm: '30px',
                        // }}
                        // right={{
                        //     base: '14px',
                        //     sm: '40px',
                        // }}
                    />
                </ModalHeader>

                <ModalBody
                    className={`${baseClass}__body`}
                    // px={{
                    //     base: '20px',
                    //     sm: '48px',
                    // }}
                    // pb={'0'}
                >
                    <Text
                        fontSize={{
                            base: '14px',
                            sm: '16px',
                        }}
                    >
                        Are you sure you want to exit the application form?
                    </Text>
                    <Text>Your progress will be saved and you can return later to complete your application.</Text>
                </ModalBody>
                <ModalFooter
                    className={`${baseClass}__footer`}
                    // px={{
                    //     base: '20px',
                    //     sm: '48px',
                    // }}
                    // pb={{
                    //     base: '20px',
                    //     sm: '44px',
                    // }}
                    // pt={{
                    //     base: '20px',
                    //     sm: '40px',
                    // }}
                    display={'flex'}
                    gap={'16px'}
                >
                    <Button width={'100%'} onClick={() => setIsModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button
                        width={'100%'}
                        // variant="primary"
                        colorScheme={'red'}
                        onClick={() => {
                            onCloseApply()
                        }}
                    >
                        {t('181')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default CloseApplyModal
